// Override console.warn to filter out specific warnings
const originalErr = console.error;
console.error = function (message, ...args) {
  if (typeof message === 'string' && message.includes('findDOMNode is deprecated')) {
    return;
  }
  if (typeof message === 'string' && message.includes('Support for defaultProps will be removed')) {
    return;
  }
  originalErr.apply(console, [message, ...args]);
};